import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


const OPTIONS = [
  {service_code: "2G", label: "2G"},
  {service_code: "3G", label: "3G"},
  {service_code: "LTE", label: "LTE"},
  {service_code: "5G", label: "5G"},
];


function WidgetServiceCodeForStats() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="서비스"
        fieldName={"service_code_stats_list"}
        options={OPTIONS.map(({ service_code, label }) => ({
          value: service_code,
          label,
        }))}
        colSpan={8} />
    </Form.Item>
  );
}


export default WidgetServiceCodeForStats;
